import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

const FLAG = { GBP: "gb", USD: "us", EUR: "eu", CAD: "ca", AUD: "au", NGN: "ng", ZAR: "za", AED: "ae", GHS: "gh", KES: "ke" };
const flagUrl = (c) => `https://flagcdn.com/w40/${FLAG[c]}.png`;

const CurrencySelect = () => {
  const { currency, setCurrency, currencies } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="currency-switcher"
        onClick={() => setOpen((o) => !o)}
        aria-label="Select currency"
        className="flex items-center gap-1.5 text-[0.66rem] tracking-[0.12em] uppercase hover:opacity-70 transition-opacity"
      >
        <img src={flagUrl(currency)} alt="" className="w-4 h-auto object-contain" />
        {currency}
        <ChevronDown size={12} strokeWidth={1.6} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="currency-menu" className="absolute right-0 mt-3 w-56 bg-ivory text-espresso shadow-xl border border-espresso/10 py-1.5 z-[70] max-h-80 overflow-auto">
          {Object.keys(currencies).map((c) => (
            <button
              key={c}
              data-testid={`currency-opt-${c}`}
              onClick={() => { setCurrency(c); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3.5 py-2 text-left text-xs hover:bg-sand/60 transition-colors ${c === currency ? "bg-sand/40" : ""}`}
            >
              <img src={flagUrl(c)} alt="" className="w-5 h-auto object-contain shrink-0" />
              <span className="tracking-[0.08em] w-9">{c}</span>
              <span className="text-espresso/45 truncate">{currencies[c]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySelect;
